// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3zW63","type":"styles_type__1wzJC","choices":"styles_choices__34CK9"};